<!--
/*******************************************************************************
*@ 컴포넌트명   : Panel.vue
*@ 컴포넌트설명 : panel 공통컴포넌트
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="notice notice-box--type">
    <div class="notice-tit">
      <p class="bullet">{{title || $t(titleI18n)}}</p>
    </div>
    <div class="notice-cont">
      <slot name="content" />
    </div>
  </div>
</template>


<script>
import { commonProps } from "@/mixins/basicComponent";
export default {
  mixins: [commonProps],
};
</script>